// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"c6475138","252":"65560c72","453":"e922d4dd"}[chunkId] + ".chunk.js";
};